module.exports = __webpack_public_path__ + "img/upload.87f51db6.svg";